<template>
    <div>
        <v-dialog v-model="dialog_filter_year" no-click-animation scrollable persistent max-width="280px" content-class="full-height" transition="dialog-bottom-transition">
            <v-card>
                <v-subheader>Select Fiscal Year</v-subheader>
                <v-card-text class="pa-0">

                    <v-list class="pa-0">
                        <template v-for="(item, index) in fiscalYears">
                            <v-list-item :key="index" @click="selectPeriod('fiscal_year', 12, item.value)" v-if="fn_checkOpeningDate(item.value)">
                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                            </v-list-item>
                        </template>
                    </v-list>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn small color="blue darken-1" text @click="closeDialogWeb">close</v-btn>
                </v-card-actions>
            </v-card>

        </v-dialog>
    </div>
</template>

<script>
    export default{
        props:['selectPeriod'],
        data(){
            return{
                dialog_filter_year:false,
                selectedFiscalYear:null,
                fiscalYears:[
                    // {"title":"FY 2021", "value":2021},
                    // {"title":"FY 2022", "value":2022}
                    {"title":"FY 22-23", "value":2022},
                    {"title":"FY 23-24", "value":2023},
                    {"title":"FY 24-25", "value":2024},
                    {"title":"FY 25-26", "value":2025}
                ]
            }
        },
        methods:{
            // openDialogWeb: function () {
            //     let currentDate = new Date();
            //     let currentYear = currentDate.getFullYear();

            //     let openingDate = new Date(this.$root.CurrentBusiness.OpeningDate);
            //     let openingYear = openingDate.getFullYear();
            //     let openingMonth = openingDate.getMonth() + 1;

            //     if(openingMonth<=3 && currentYear <= openingYear){
            //         this.selectedFiscalYear = openingYear - 1;
            //     }
            //     else{
            //         this.selectedFiscalYear = openingYear;
            //     }

            //     this.dialog_filter_year = true;
            // },
            openDialogWeb: function () {
                this.dialog_filter_year = true;
            },
            closeDialogWeb: function () {
                this.dialog_filter_year = false;
            },
            fn_checkOpeningDate: function(item){
                let openingDate = new Date(this.$root.CurrentBusiness.OpeningDate);
                let openingMonth = openingDate.getMonth() + 1;
                let openingYear = openingDate.getFullYear();
                openingMonth <= 3 ? openingYear = openingYear - 1 : '';
                if(item >= openingYear){
                    return true;
                }
                else{
                    return false;
                }
            }
        }
    }
</script>